var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['waiting',_vm.isActive ? 'active':''],attrs:{"id":"waiting1"},on:{"click":_vm.onScreenClick}},[_c('div',{staticClass:"waitElements"},[_vm._m(0),_c('div',{staticClass:"waitText"},[_vm._v(_vm._s(_vm.localize('start')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waitLogo"},[_c('img',{attrs:{"src":"images/mis-ds.svg"}})])
}]

export { render, staticRenderFns }